<div class="grey-outline" [ngClass]="disabled ? 'disabled' : ''" *ngIf="numberOfOptions" [ngStyle]="{ width: getContainerWidth() }">
  <div class="slider" [ngStyle]="{ width: getSliderWidth(), transform: getTransform() }"></div>

  <ng-container *ngFor="let option of optionList">
    <div class="option-wrapper" [ngStyle]="{ width: getSliderWidth(), 'min-Width': getSliderWidth(), cursor: disabled ? 'default' : 'pointer' }" *ngIf="numberOfOptions >= 1" (click)="select(option)">
      <div [ngClass]="selectedOption === option ? 'selected-option' : 'not-selected-option'">
        <img [ngStyle]="{ width: '20px', height: '20px', filter: selectedOption === option && option.filter === true ? imageFilter.white : 'none' }" [src]="option.value" />
      </div>
    </div>
  </ng-container>
</div>
